import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { useManageConnectorsHref } from '#pplx/frontend/apps/ask/connectors/hooks/useManageConnectorsHref.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
export const SourcesMenuManageConnectors = memo(function SourcesMenuManageConnectors() {
    const manageConnectorsHref = useManageConnectorsHref();
    return (_jsx(DropdownMenu.LinkItem, { href: manageConnectorsHref, target: "_blank", rel: "noopener", leadingAccessory: _jsx(Icon, { icon: $icon('settings'), size: "small" }), children: _jsx(FormattedMessage, { defaultMessage: "Manage Connectors", id: "cb57168b62", description: "Menu item to navigate to the connectors page" }) }));
});
//# sourceMappingURL=SourcesMenuManageConnectors.js.map